export const uniqueBy = (arr, prop) =>
  arr
    .map((menu) => menu[prop])
    .filter((pro, index, ar) => ar.indexOf(pro) === index)

export const formatFilters = ({ filters }) => {
  const formattedFilters = {
    vertical: uniqueBy(filters, 'vertical').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    clasificacion: uniqueBy(filters, 'clasificacion').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    categoria: uniqueBy(filters, 'categoria').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    subcategoria: uniqueBy(filters, 'subcategoria').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    segmento: uniqueBy(filters, 'segmento').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    subsegmento: uniqueBy(filters, 'subsegmento').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    marca: uniqueBy(filters, 'marca').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    familia: uniqueBy(filters, 'familia').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    acreedor: uniqueBy(filters, 'acreedor').map((name) =>
      name !== ' ' ? name : '---VACIO---',
    ),
    grupo_compras: uniqueBy(filters, 'grupo_compras').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    indicador_abc: uniqueBy(filters, 'indicador_abc').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    estado: uniqueBy(filters, 'estado').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
    estado_obsoleto: uniqueBy(filters, 'estado_obsoleto').map((name) =>
      name !== '' ? name : '---VACIO---',
    ),
  }

  if (filters.some((filter) => filter.hasOwnProperty('gnombre'))) {
    formattedFilters.gnombre = uniqueBy(filters, 'gnombre').map((name) =>
      name !== '' ? name : '---VACIO---',
    )
  }

  if (filters.some((filter) => filter.hasOwnProperty('pnombre'))) {
    formattedFilters.pnombre = uniqueBy(filters, 'pnombre').map((name) =>
      name !== '' ? name : '---VACIO---',
    )
  }

  return formattedFilters
}

export const filtrarArray = (array, filtro) => {
  const resultado = array.filter(
    (obj) =>
      (filtro.estado.includes(obj.estado) || filtro.estado.length === 0) &&
      (filtro.clasificacion.includes(obj.clasificacion) ||
        filtro.clasificacion.length === 0) &&
      (filtro.categoria.includes(obj.categoria) ||
        filtro.categoria.length === 0) &&
      (filtro.subcategoria.includes(obj.subcategoria) ||
        filtro.subcategoria.length === 0) &&
      (filtro.segmento.includes(obj.segmento) ||
        filtro.segmento.length === 0) &&
      (filtro.subsegmento.includes(obj.subsegmento) ||
        filtro.subsegmento.length === 0) &&
      (filtro.marca.includes(obj.marca) || filtro.marca.length === 0) &&
      (filtro.familia.includes(obj.familia) || filtro.familia.length === 0) &&
      (filtro.acreedor.includes(obj.acreedor) ||
        filtro.acreedor.length === 0) &&
      (filtro.grupo_compras.includes(obj.grupo_compras) ||
        filtro.grupo_compras.length === 0) &&
      (filtro.indicador_abc.includes(obj.indicador_abc) ||
        filtro.indicador_abc.length === 0) &&
      (filtro.vertical.includes(obj.vertical) ||
        filtro.vertical.length === 0) &&
      (!filtro.gnombre ||
        filtro.gnombre.length === 0 ||
        filtro.gnombre.includes(obj.gnombre)) &&
      (!filtro.pnombre ||
        filtro.pnombre.length === 0 ||
        filtro.pnombre.includes(obj.pnombre)) &&
      (!filtro.estado_obsoleto ||
        filtro.estado_obsoleto.length === 0 ||
        filtro.estado_obsoleto.includes(obj.estado_obsoleto)),
  )

  return resultado
}
